import React from 'react';
import { css } from 'aphrodite/no-important';
import styles from './Accordion.styles';

import AccordionSite from '../accordionsite/AccordionSite';

const Accordion = props => {
  let renderSite = (site, index) => (
    <div className={css(styles.site)} key={index}>
      <AccordionSite
        site={site}
        areas={props.areas}
        zones={props.zones}
        locations={props.locations}
        delete={props.onDeleteSite}
        hideMenu={props.hideMenu}
        onOpenSite={props.onOpenSite}
        onOpenArea={props.onOpenArea}
        onOpenZone={props.onOpenZone}
        onDeleteLocation={props.onDeleteLocation}
        onDeleteZone={props.onDeleteZone}
        onDeleteArea={props.onDeleteArea}
        onEditArea={props.onEditArea}
        onEditZone={props.onEditZone}
        onEditLocation={props.onEditLocation}
        onEditSite={props.onEditSite}
        onEditSiteLabels={props.onEditSiteLabels}
      />
    </div>
  );
  return <div>{props.sites && props.sites.map(renderSite)}</div>;
};

export default Accordion;



// WEBPACK FOOTER //
// ./src/components/data/accordion/Accordion.js